var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center"},_vm._l((_vm.btns),function(ref,index){
var text = ref[0];
var rounded = ref[1];
return _c('v-menu',{key:text,attrs:{"rounded":rounded,"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"white--text ma-8",attrs:{"color":_vm.colors[index]}},'v-btn',attrs,false),on),[_vm._v(" "+_vm._s(text)+" Radius ")])]}}],null,true)},[_c('v-list',_vm._l((_vm.items),function(item){return _c('v-list-item',{key:item,attrs:{"link":""}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(item)}})],1)}),1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }